var map = {
	"./add.svg": 4780,
	"./clock-white.svg": 2955,
	"./friends-selected.svg": 7039,
	"./friends-white.svg": 5489,
	"./friends.svg": 8785,
	"./heart-selected.svg": 2984,
	"./heart-white.svg": 7743,
	"./heart.svg": 3972,
	"./plus.svg": 3189,
	"./profile-edit-selected.svg": 2470,
	"./profile-edit.svg": 8979,
	"./recipes-selected.svg": 1733,
	"./recipes.svg": 2921,
	"./swipe-selected.svg": 7391,
	"./swipe.svg": 7979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;